import { Box, IconButton } from '@mui/material';
import { ControlPosition, MapControl, useMap } from '@vis.gl/react-google-maps';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface ZoomControlProps {
  controlPosition: ControlPosition;
}

const ZoomControl: React.FC<ZoomControlProps> = ({ controlPosition }) => {
  const map = useMap();

  return (
    <MapControl position={controlPosition}>
      <Box className="map-control" sx={{ marginRight: '22px' }}>
        <IconButton
          aria-label="Zoom In"
          title="Zoom In"
          size="small"
          className={'map-control-icon map-control-single-state'}
          onClick={(e) => {
            if (map) {
              if (map) {
                const zoom = map.getZoom();
                if (zoom === undefined) return;
                map.setZoom(zoom + 1);
              }
            }
          }}
          sx={{ marginBottom: '7px', minWidth: 0, p: 0, borderRadius: '8px' }}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          title="Zoom Out"
          aria-label="Zoom Out"
          size="small"
          className={'map-control-icon map-control-single-state'}
          onClick={(e) => {
            if (map) {
              if (map) {
                const zoom = map.getZoom();
                if (zoom === undefined) return;
                map.setZoom(zoom - 1);
              }
            }
          }}
          sx={{ minWidth: 0, p: 0, borderRadius: '8px', fontSize: '1.2rem' }}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
    </MapControl>
  );
};

export default ZoomControl;
